const CONFIG = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  redirectUri: process.env.REACT_APP_AUTH0_REDIRECT_URI,
  responseType: process.env.REACT_APP_AUTH0_RESPONSE_TYPE,
  scope: process.env.REACT_APP_AUTH0_SCOPE
};

export default CONFIG;
